export default __webpack_public_path__ + "static/media/PastaMeatball.43863ee2.jpg";